import React from 'react'
import qs from 'qs'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const filters: App.OfferListFilters = {
  durationMax: 8,
}

function CruisePageShortTermCruisesCarousel() {
  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          Short term <i>cruises</i>
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          View all
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageShortTermCruisesCarousel
